import { createSlice } from '@reduxjs/toolkit';
import {
    getDashbordById,
    saveDashboardAsync,
    getDowntimeFieldsData,
    getMachineSerialNumbers,
    homePageAsync,
    writeValue,
} from './dashboardActions';

const initialState = {
    panels: [],
    dashboards: [],
    clipboard: null,
    dashboardEdited: null,
    dashbord: null,
    newDashboard: null,
    breakpoint: '',
    layouts: {},
};

export const dasbhoardSlice = createSlice({
    name: 'dashboardSlice',
    initialState,
    reducers: {
        changeBreakpoint: (state, action) => {
            return {
                ...state,
                breakpoint: action.payload,
            };
        },
        updateLayout: (state, action) => {
            return {
                ...state,
                layouts: action.payload,
            };
        },

       
       
      
    },
    extraReducers: builder => {
        builder
            .addCase(homePageAsync.fulfilled, (state, action) => {
                return {
                    ...state,
                    dashbord: action.payload,
                    panels: action.payload.panels,
                };
            })
         
            .addCase(writeValue.fulfilled, (state, action) => {
                const newPanels = [...state.panels];
                newPanels[0] = { ...newPanels[0], WRITE_RES: action.payload };
                return {
                    ...state,
                    panels: [...newPanels],
                };
            });
    },
});

export const {
    addPanel,
    updatePanel,
    removePanel,
    saveDashboard,
    updateDashboard,
    clearPanels,
    duplicatePanel,
    copyPanel,
    pastePanel,
    editPanel,
    setEditedDashboardId,
    setHomePage,
    resetNewDashboard,
    createNewDashboard,
    configureNewDashboard,

    // Related to Panels layout
    changeBreakpoint,
    updateLayout,
} = dasbhoardSlice.actions;

export const getDashbordPanels = state => state.dashboard.panels;
export const getCurrentBreakpoint = state => state.dashboard.breakpoint;
export const getChangedLayout = state => state.dashboard.layouts;

export default dasbhoardSlice.reducer;
